import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
const findAccounts = createAsyncThunk("account/findAccounts", async (args, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);
    headers.append("Content-Type", "application/json");

    const response = await fetch(`${api.baseURL}account`, {
      method: "GET",
      headers: headers,
    });
    if (!response.ok) {
      throw new Error("Error");
    }
    let data = await response.json();
    return data;
  } catch (error) {
    rejectWithValue(error);
  }
});

export default findAccounts;
